<footer class="grid-container">
    <div class="row">
        <div class="col-2">
            <h5 [class.empty]="footer.col1.title === null">
                {{ footer.col1.title || '&nbsp;' }}
            </h5>
            <ul class="links">
                <li *ngFor="let link of footer.col1.links">
                    <a
                        *ngIf="link.external !== true"
                        [routerLink]="link.url"
                        [queryParams]="link.params"
                    >
                        {{ link.title }}
                    </a>
                    <a
                        *ngIf="link.external === true"
                        target="_blank"
                        rel="noopener"
                        [href]="link.url"
                    >
                        {{ link.title }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-2">
            <h5 [class.empty]="footer.col2.title === null">
                {{ footer.col2.title || '&nbsp;' }}
            </h5>
            <ul class="links">
                <li *ngFor="let link of footer.col2.links">
                    <a
                        *ngIf="link.external !== true"
                        [routerLink]="link.url"
                        [queryParams]="link.params"
                    >
                        {{ link.title }}
                    </a>
                    <a
                        *ngIf="link.external === true"
                        target="_blank"
                        rel="noopener"
                        [href]="link.url"
                    >
                        {{ link.title }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-2">
            <h5 [class.empty]="footer.col3.title === null">
                {{ footer.col3.title || '&nbsp;' }}
            </h5>
            <ul class="links">
                <li *ngFor="let link of footer.col3.links">
                    <a
                        *ngIf="link.external !== true"
                        [routerLink]="link.url"
                        [queryParams]="link.params"
                    >
                        {{ link.title }}
                    </a>
                    <a
                        *ngIf="link.external === true"
                        target="_blank"
                        rel="noopener"
                        [href]="link.url"
                    >
                        {{ link.title }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-2">
            <h5 [class.empty]="footer.col4.title === null">
                {{ footer.col4.title || '&nbsp;' }}
            </h5>
            <ul class="links">
                <li *ngFor="let link of footer.col4.links">
                    <a
                        *ngIf="link.external !== true"
                        [routerLink]="link.url"
                        [queryParams]="link.params"
                    >
                        {{ link.title }}
                    </a>
                    <a
                        *ngIf="link.external === true"
                        target="_blank"
                        rel="noopener"
                        [href]="link.url"
                    >
                        {{ link.title }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-4">
            <h5 [class.empty]="footer.col5.title === null">
                {{ footer.col5.title || '&nbsp;' }}
            </h5>
            <ul class="socials">
                <li *ngFor="let social of footer.col5.socials">
                    <a
                        [href]="social.url"
                        target="_blank"
                        rel="noopener"
                        [attr.aria-label]="social.label"
                    >
                        <mat-icon [svgIcon]="social.type"></mat-icon>
                    </a>
                </li>
            </ul>
            <app-button
                [style.width]="footer.col5.socials.length * 71 - 15 + 'px'"
                [config]="{
                    title: 'Subscribe to Updates',
                    fill: 'outline',
                    background: 'separator',
                    type: 'button'
                }"
                (click)="subscribeToMailingList()"
            ></app-button>
        </div>
    </div>
    <div class="row sub-footer">
        <div class="col-9 disclaimer">
            <hr />
            <div class="disclaimer-content">
                &copy; {{ currentYear }} LISTIQUE LTD.
                <div>
                    <a routerLink="/legals/privacy-policy">PRIVACY POLICY</a> |
                    <a routerLink="/legals/terms-of-use">TERMS OF USE</a>
                </div>
            </div>
        </div>
        <!--<div class="col-3 service">
            <a routerLink="/categories/gardners">
                Looking for a gardener?<br />View our hand-picked<br />selection.
            </a>
        </div>-->
    </div>
    <!--<div class="footer-service"><img loading="lazy" src="/assets/images/leaves.png" /></div>-->
</footer>
